module.exports = __webpack_public_path__ + "static/media/DanielMcMahon.5db65310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/DanielMcMahon.jpg
// module id = 1482
// module chunks = 0